import React, { useState, useEffect, useRef } from "react";
import Select from "react-select";
import { Container, Card, Row, Col, Accordion, Button, Modal, Form, Offcanvas } from "react-bootstrap";
import { FaClipboardList, FaSmile, FaInfoCircle, FaRegCalendarCheck, FaHospitalUser, FaUserFriends, FaStar } from 'react-icons/fa';
import Glide from "@glidejs/glide";
import * as Icons from 'react-feather';
import "@glidejs/glide/dist/css/glide.core.min.css";
import "@glidejs/glide/dist/css/glide.theme.min.css";
import Center from "react-center";
import Step1Page from "./registrasi/Step1Page";
import Step2Page from "./registrasi/Step2Page";
import Step3Page from "./registrasi/Step3Page";
import Step4Page from "./registrasi/Step4Page";
import Step6Page from "./registrasi/Step6Page";
import SuccessPage from "./registrasi/SuccessPage";

import { style } from "view/Style";
import Axios from "axios";
import { urlAPI } from "Common";
import FailedAlert from "./component/FailedAlert";
import InfoAlert from "./component/InfoAlert";
import ConfirmationAlert from "./component/ConfirmationAlert";
import moment from "moment";
import { FloatingWhatsApp } from "react-floating-whatsapp-button";
import "react-floating-whatsapp-button/dist/index.css";
import JadwalSection from "./jadwal/JadwalSection";
import AntrianSection from "./jadwal/AntrianSection";
import { useHistory, useLocation } from "react-router-dom";
import ModalPengumuman from "./component/ModalPengumuman";
import ModalInformasi from "./component/ModalInformasi";
import PelangganSection from "./jadwal/PelangganSection";
import ModalHeader from "react-bootstrap/esm/ModalHeader";

const initStep1 = {
  sbu: null,
  sbuname: null,
  unit: null,
  unitname: null,
  date: moment().add(0, "days").format("YYYY-MM-DD"),
  rs: "",
  registrationType: "all",
};

const initStep2 = {
  idjadwal: null,
  kodedokter: null,
  namadokter: null,
  kodedokterbpjs: null,
  kodeunitbpjs: null,
  ruang: null,
  jam: null,
  sesi: null,
};

const initStep3 = {
  norm: null,
  nama: null,
  tgllahir: null,
  namacust: null,
  jaminan: null,
  noktp: null,
  noasuransi: "",
  paketmcu:"",
};

const initStep4 = { tlp: "", nonBpjs: "0" };

const initDataBPJS = {
  kodedokterbpjs: null,
  kodeunitbpjs: null,
  kuota: 0,
};

// const initStep1 = {
//   sbu: "RSPG",
//   sbuname: "Rumah Sakit Petrokimia Gresik",
//   unit: "Q03",
//   unitname: "SPESIALIS PNY.DALAM",
//   date: moment("2021-08-09").format("YYYY-MM-DD"),
// };
// const initStep2 = {
//   kodedokter: "S74",
//   namadokter: "ABDUL FATAH, SP.PD",
//   ruang: "POLI 6",
//   jam: "08:30 - 11:00",
// };
// const initStep3 = {
//   norm: "558662",
//   nama: "SRI SETYOWATI",
//   tgllahir: "1957-11-20 00:00:00.000",
//   namacust: "BPJS KESEHATAN ",
// };

const initSuccessState = {
  sbuname: "",
  unitname: "",
  doktername: "",
  tanggal: "",
  jam: "",
  nobooking: "",
  antrian: "",
};

const initFilterJadwal = {
  sbu: "defaultSBUValue",
  poli: null,
  namapoli: "",
  jadwaltype: null,
};

const initDataDokter = {
  count: 0,
  rows: [],
};

const initFilterAntrian = {
  sbu: null,
  poli: null,
  namapoli: "",
};

const initFilterRiwayat = {
  nama: "",
  poli: "",
  doktername: "",
  tanggal: "",
  unitname: "",
  sbuname: "",
}

const initSEP = 0;

export default function App(props) {
  const myRef = useRef(null);
  const sliderRef = useRef(null);
  const [activeStep, setActiveStep] = useState(1);
  const [dataStep1, setDataStep1] = useState({ sbu: "", unit: "", date: "", registrationType: ""});
  const [dataStep2, setDataStep2] = useState(initStep2);
  const [dataStep3, setDataStep3] = useState(initStep3);
  const [dataStep4, setDataStep4] = useState(initStep4);
  const [dataBPJS, setDataBPJS] = useState(initDataBPJS);
  const [SEP, setSEP] = useState(initSEP);
  const [dataRujukan, setDataRujukan] = useState([]);
  const [filterJadwal, setFilterJadwal] = useState(initFilterJadwal);
  const [filterAntrian, setFilterAntrian] = useState(initFilterAntrian);
  const [suratKontrol, setSuratKontrol] = useState([]);
  const [filterRiwayat, setFilterRiwayat] = useState(initFilterRiwayat);
  const [dataDokter, setDataDokter] = useState(initDataDokter);
  const [showJadwal, setShowJadwal] = useState(false);

  const [successState, setSuccessState] = useState(initSuccessState);
  const history = useHistory();

  const [messageState, setMessageState] = useState("");
  const [showFailed, setShowFailed] = useState(false);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [confirmationFrom, setConfirmationFrom] = useState(null);
  const [showInfo, setShowInfo] = useState(false);

  const [selectorUnit, setSelectorUnit] = useState([]);
  const [loadingUnit, setLoadingUnit] = useState(false);
  const [unitJenis3, setUnitJenis3] = useState(null);
  const [handleNext, sethandleNext] = useState([]);

  const [selectorAntrian, setSelectorAntrian] = useState([]);
  const [loadingAntrian, setLoadingAntrian] = useState(false);
  const [antrianJenis3, setAntrianJenis3] = useState(null);

  const [loadingPengumuman, setLoadingPengumuman] = useState(false);
  const [openPengumuman, setOpenPengumuman] = useState(false);
  const [dataPengumuman, setDataPengumuman] = useState({});
  const [loadingInformasi, setLoadingInformasi] = useState(false);
  const [openInformasi, setOpenInformasi] = useState(false);
  const [dataInformasi, setDataInformasi] = useState({});
  const [tanggalServer, setTanggalServer] = useState(null);
  const [tanggalClient, setTanggalClient] = useState(null);
  const [statusKirimBPJS, setStatusKirimBPJS] = useState(null);
  const [selectedMenu, setSelectedMenu] = useState(null);
  const [selectedSBU, setSelectedSBU] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [showModel, setShowModel] = useState(false);
  const [hoverIndex, setHoverIndex] = useState(null);
  const location = useLocation();
  const [showPopup, setShowPopup] = useState(false);
  const [showUnitDateModal, setShowUnitDateModal] = useState(false);
  const [visitDate, setVisitDate] = useState(null);
  const [showRegistrationModal, setShowRegistrationModal] = useState(false);
  const [modalHistory, setModalHistory] = useState([]);
  const [showExclusiveModal, setShowExclusiveModal] = useState(false);
  const [registrationType, setRegistrationType] = useState(null); //Eksklusif atau Reguler
  const greenGradient = "linear-gradient(135deg, #56ab2f, #a8e063)";
  const greenDark = "#2e7d32";
  const greenSoft = "#f6fbf7";
const SPECIAL_QUOTA_BPJS_LIMIT = 2;
const SPECIAL_QUOTA_UMUM_LIMIT = 2;

  const RIWAYAT_CHECK_UNITS = ["G16", "G17", "G18", "H04"];

  const UNIT_JAM_BUKA = ["A62", "P48", "G16", "G17", "G18"];
  const JAM_BUKA = 8; // 08:00 WIB (jam server)
  const PESAN_BELUM_BUKA =
    "Pendaftaran online untuk poli ini dibuka mulai pukul 08:00 WIB. Silakan kembali lagi setelah pukul 08:00 WIB.";
  const isBelumBuka = (unit, serverRow) =>
    UNIT_JAM_BUKA.includes(String(unit ?? "").trim().toUpperCase()) &&
    Number(serverRow?.Jam) < JAM_BUKA;

  const handleOpenExclusiveModal = () => {
    setShowExclusiveModal(true);
  };

// const handleSelectRegistrationType = (type) => {
//   setRegistrationType(type);
//   setDataStep1((prev) => ({ ...prev, registrationType: type }));
//   setShowExclusiveModal(false);

//   setShowUnitDateModal(true);
//   if (selectedSBU?.value && type) {
//     fetchSelectorUnit(selectedSBU.value, type, setDataStep1);
//   }
// };

const handleSelectRegistrationType = (type) => {
  setRegistrationType(type);
  setDataStep1((prev) => ({ ...prev, registrationType: type }));
  setShowExclusiveModal(false);

  if (["REGULER", "ABYAKTA", "EKSKLUSIF"].includes(type)) {
    setLoadingPengumuman(true);
    Axios.get(`${urlAPI}/public/regonline/checkpengumuman?sbu=${selectedSBU?.value}&type=${type}`)
      .then((response) => {
        setLoadingPengumuman(false);
        const result = response?.data?.result;
        if (Array.isArray(result) && result.length > 0) {
          setDataPengumuman(result[0]);
          setOpenPengumuman(true); // tampilkan pengumuman dulu
        } else {
          // kalau tidak ada pengumuman langsung buka modal unit & tanggal
          setShowUnitDateModal(true);
        }
      })
      .catch((err) => {
        setLoadingPengumuman(false);
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
      });
  } else {
    setShowUnitDateModal(true);
  }

  if (selectedSBU?.value && type) {
    fetchSelectorUnit(selectedSBU.value, type, setDataStep1);
  }
};

// handler ketika user tutup pengumuman
const handleClosePengumuman = () => {
  setOpenPengumuman(false);
  setShowUnitDateModal(true);
};


console.log("datastep1:", dataStep1);
console.log ("registrationType:", registrationType);
  const handleOpenModal = (menu) => {
    setSelectedMenu(menu);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedMenu(null);
  };

  const openUnitDateModal = () => {
  if (!registrationType) {
    setShowExclusiveModal(true);
    return;
  }
  setShowUnitDateModal(true);
};

  // const handleSelectSBU = (sbu) => {
  //   setSelectedSBU(sbu);
  //   setDataStep1({ ...dataStep1, sbu: sbu.value, unit: "", date: "", registrationType: "" });
  //   localStorage.setItem("selectedSBU", JSON.stringify(sbu));
  //   setShowModel(true);
  // };

  const handleSelectSBU = (sbu) => {
  setSelectedSBU(sbu);
  setDataStep1({ ...dataStep1, sbu: sbu.value, unit: "", date: "", registrationType: "" });
  setRegistrationType(null);
  setShowExclusiveModal(true);
  setShowUnitDateModal(false);
  setShowModel(true);
};
  
  console.log (dataStep1?.sbu)
  const handleHospitalSelect = (sbu) => {
    fetchSelectorUnit(sbu.value);
    // setDataStep1({ ...dataStep1, sbu: sbu.value, sbuname: sbu.label, unit: null, unitname: null });
    setShowUnitDateModal(true);
  };
  
  const handleUnitSelect = (e) => {
    setDataStep1({ ...dataStep1, unit: e.value, unitname: e.label });
    setUnitJenis3(e.jenis3);
  };
  
  
  const handleDateSelect = () => {
    setDataStep1({ ...dataStep1, visitDate: visitDate });
    setShowUnitDateModal(false);
    setShowRegistrationModal(true);
    setModalHistory(["registration"]);
  };  

  const handleRegistrationModalClose = (registered) => {
    setDataStep1({ ...dataStep1, rs: registered ? "Pernah" : "Belum" });
    setShowRegistrationModal(false);
    setModalHistory([]);
    handleNext();
  }; 
  
  const handleSelect = (sbu, klasifikasi) => {
    setDataStep1({
      ...dataStep1,
      sbu: sbu.value,
      sbuname: sbu.label,
      unit: null,
      unitname: null,
      registrationType: null,
    });
    setSelectedSBU(sbu);
    setRegistrationType(klasifikasi);
    setShowPopup(true);
    fetchInformasiSBU(sbu.value);
  };

  const handleNavigate = (step, doctor) => {
    setDataStep2({
      idjadwal: doctor?.id,
      kodedokter: doctor?.kodedokter,
      namadokter: doctor?.namadokter,
      kodedokterbpjs: doctor?.kodedokterbpjs,
      kodeunitbpjs: doctor?.kodeunitbpjs,
      ruang: doctor?.ruang,
      jam: doctor?.jam,
      rs: doctor?.rs,
      tanggal: doctor?.tanggal,
      poli: doctor?.poli,
      dokter: doctor?.dokter,
      sesi: doctor?.sesi,
    });
    // console.log("Navigasi ke:", step, "dengan data dokter:", doctor);
  
    if (step === "Step3Page") {
      setActiveStep(3); // Pindah ke Step3Page jika sudah pernah periksa
    } else if (step === "Step6Page") {
      setActiveStep(6); // Pindah ke Step6Page jika belum pernah periksa
    }
  };
  
  const [selectorRS] = useState([
    {
      value: "Pernah",
      label: "Pernah",
    },
    {
      value: "Belum",
      label: "Belum",
    },
  ]);

  const selectorSBU = [
    { value: "RSPG", 
      label: "Rumah Sakit Petrokimia Gresik", 
      location: "https://goo.gl/maps/Kaugv4ev8JbqkSDr7", 
      img: "assets/img/rspgnew.png", 
      profile: "RS Petrokimia Gresik (RSPG) adalah rumah sakit umum yang berlokasi di Jl. Jenderal Ahmad Yani, Gresik. Berawal sebagai poliklinik pada 1971, RSPG resmi menjadi rumah sakit pada 11 Maret 1992 dan dikelola oleh PT Petro Graha Medika sejak 2004. Dengan fasilitas modern dan tenaga medis profesional, RSPG berkomitmen memberikan pelayanan kesehatan terbaik bagi masyarakat."
     },
      
    { value: "GRAHU", 
      label: "Rumah Sakit Grha Husada", 
      location: "https://goo.gl/maps/YtnjVQkmEX7m9tXD9", 
      img: "assets/img/rsghnew.png", 
      profile: "RS Grha Husada Gresik adalah rumah sakit umum kelas D yang beroperasi sejak 31 Desember 2013. Berada di bawah naungan PT Petro Graha Medika, rumah sakit ini berlokasi di Jl. Padi No. 03, Komplek Perumahan PT Petrokimia Gresik. Ditetapkan sebagai RS kelas D oleh Kemenkes RI pada 25 Oktober 2013, RS Grha Husada menyediakan layanan kesehatan terintegrasi bagi masyarakat." },

    { value: "DRIYO", 
      label: "RSPG Driyorejo", 
      location: "https://goo.gl/maps/RCTEzS4JEMgRGNwt8", 
      img: "assets/img/rspgd.png", 
      profile: "RS Petrokimia Gresik Driyorejo (RSPG Driyorejo) adalah rumah sakit umum yang berlokasi di Driyorejo, Gresik. Sebagai bagian dari PT Petro Graha Medika, rumah sakit ini berkomitmen memberikan layanan kesehatan berkualitas dengan fasilitas modern dan tenaga medis profesional. Dengan pelayanan yang cepat, aman, dan berkualitas, RSPG Driyorejo hadir untuk memenuhi kebutuhan kesehatan masyarakat sekitar." },

    // { value: "PPK1", 
    //   label: "Klinik PPK I PT Petrokimia Gresik", 
    //   location: "https://goo.gl/maps/4xYCCL2nRrFaBq9k9",  
    //   img: "assets/img/logoppk.png", 
    //   profile: "Klinik PPK I PT Petrokimia Gresik memberikan layanan kesehatan bagi karyawan dan masyarakat sekitar." },

    // { value: "KALIMANTAN", 
    //   label: "Klinik Satelit Kalimantan", 
    //   location: "https://goo.gl/maps/9pMZG3iPkkdbD5o88", 
    //   img: "assets/img/logosatkal.png", 
    //   profile: "Klinik Satelit Kalimantan menyediakan layanan kesehatan dasar dan spesialis." },

    // { value: "WA", 
    //   label: "Klinik PPK I Wringinanom Gresik", 
    //   location: "https://goo.gl/maps/cDmnMQjzbGARio539", 
    //   img: "assets/img/logoppk.png", 
    //   profile: "Klinik PPK I Wringinanom Gresik menyediakan layanan kesehatan dasar dan spesialis." },
  ];

  const getRegistrationOptions = () => {
    if (selectedSBU?.value === "RSPG") {
      return [
        { value: "PRIORITAS", label: "Prioritas", img: "assets/img/prioritas.jpg" },
        { value: "ABYAKTA", label: "Abyakta", img: "assets/img/abhiyakta.jpg" },
        { value: "REGULER", label: "Reguler", img: "assets/img/reguler.jpg" },
      ];
    } 
    else if (selectedSBU?.value === "GRAHU") {
      return [
        { value: "EKSKLUSIF", label: "EKSEKUTIF", img: "assets/img/eksklusif.jpg" },
        { value: "REGULER", label: "REGULER", img: "assets/img/reguler.jpg" },
      ];
    }
    else if (selectedSBU?.value === "DRIYO") {
      return [
        { value: "REGULER", label: "Reguler", img: "assets/img/reguler.jpg" },
      ];
    }
    return [];
  };

  const menuLayanan = [
    {
      label: "Daftar Online",
      icon: <FaClipboardList size={40} />,
      component: "PelangganSection",
    },
    {
      label: "Riwayat Kunjungan",
      icon: <FaUserFriends size={40} />,
      component: "PelangganSection",
    },
    {
      label: "Jadwal Dokter",
      icon: <FaHospitalUser size={40} />,
      component: "JadwalSection",
    },
    {
      label: "Informasi Antrian",
      icon: <FaInfoCircle size={40} />,
      component: "AntrianSection",
    },
    {
      label: "Rencana Kontrol",
      icon: <FaRegCalendarCheck size={40} />,
      component: "AntrianSection",
    },
    {
      label: "Kuisioner Pelanggan",
      icon: (
        <div style={{ display: "flex", alignItems: "center", gap: "2px" }}>
          <FaStar size={4} />
          <FaStar size={12} />
          <FaStar size={20} />
          <FaStar size={12} />
          <FaStar size={4} />
        </div>
      ),
      component: "PelangganSection",
    },
    // {
    //   label: "Billing Perawatan",
    //   icon: <Icons.FileText size={40} color="#097a75" />,
    //   component: "PelangganSection",
    // },
  ];
  

  const [noBPJS, setNoBPJS] = useState(""); //digunakan kalau user memilih jaminan bpjs dan jenis pengenal bukan nomor bpjs
  // console.log("dataStep 1",dataStep1);
  // console.log("dataStep 2", dataStep2);
  // console.log("dataStep 3", dataStep3);
  // console.log("surat Kontrol", suratKontrol[0]?.noSuratKontrol);
  // console.log("dataBPJS", dataBPJS);
  // console.log("SEP", SEP);
  // const fetchSelectorUnit = (sbu) => {
  //   Axios.get(urlAPI + "/public/unit/selectorrawatjalan?sbu=" + sbu)
  //     .then((response) => {
  //       if (response?.data?.result?.length > 0) {
  //         const pilihanNull = { value: null, label: "Pilih Unit Tujuan..." };
  //         const selectorTemp = response?.data?.result?.map((obj) => ({
  //           value: obj?.KODEUNIT,
  //           label: obj?.NAMAUNIT,
  //           name: obj?.NAMAUNIT,
  //           jenis3: obj?.JENIS3,
  //         }));
  //         setSelectorUnit([pilihanNull, ...selectorTemp]);
  //         setLoadingUnit(false);
  //       } else {
  //         setSelectorUnit([]);
  //         setLoadingUnit(false);
  //       }
  //     })
  //     .catch((err) => {
  //       setMessageState(err?.response?.data?.message ?? err?.response);
  //       setShowFailed(true);
  //       setLoadingUnit(false);
  //     });
  // };

const fetchSelectorUnit = (sbu, registrationType) => {
  setLoadingUnit(true);
  // console.log("Fetching units for SBU:", sbu, "with registrationType:", registrationType)
  Axios.get(urlAPI + "/public/unit/selectorrawatjalan", {
    params: { sbu, registrationType },
    
  })
    .then((response) => {
      if (response?.data?.result?.length > 0) {
        const pilihanNull = { value: null, label: "Pilih Unit Tujuan..." };
        const selectorTemp = response?.data?.result?.map((obj) => ({
          value: obj?.KODEUNIT,
          label: obj?.NAMAUNIT,
          name: obj?.NAMAUNIT,
          jenis3: obj?.JENIS3,
          registrationType: registrationType,
        }));
        setSelectorUnit([pilihanNull, ...selectorTemp]);
        // if (setDataStep1 && selectorTemp.length > 0) {
        //   setDataStep1((prev) => ({
        //     ...prev,
        //     unit: selectorTemp[0].value,
        //     unitname: selectorTemp[0].label,
        //   }));
        // }
        setLoadingUnit(false);
      } else {
        setSelectorUnit([]);
        // if (setDataStep1) {
        //   setDataStep1((prev) => ({
        //     ...prev,
        //     unit: null,
        //     unitname: null,
        //   }));
        // }
        setLoadingUnit(false);
      }
    })
    .catch((err) => {
      // console.log(err);
      setMessageState("Terjadi kesalahan saat mengambil data unit.");
      setShowFailed(true);
      setLoadingUnit(false);
    });
};
  
const fetchInformasiSBU = (sbu) => {
  setLoadingInformasi(true);
  Axios.get(`${urlAPI}/public/regonline/checkinformasi?sbu=${sbu}`)
    .then((response) => {
      setLoadingInformasi(false);
      const result = response?.data?.result;
      if (Array.isArray(result) && result.length > 0) {
        setDataInformasi({ ...result[0] });
        setOpenInformasi(true);
      } else {
        setDataInformasi({});
        setOpenInformasi(false);
      }
    })
    .catch((error) => {
      console.error("Gagal mengambil informasi SBU:", error);
      setLoadingInformasi(false);
      setDataInformasi({});
      setOpenInformasi(false);
    });
};

  const fetchSelectorUnitAntrian = (sbu) => {
    Axios.get(urlAPI + "/public/unit/selectorrawatjalan?sbu=" + sbu)
      .then((response) => {
        if (response?.data?.result?.length > 0) {
          const pilihanNull = { value: null, label: "Pilih Unit Tujuan..." };
          const selectorTemp = response?.data?.result?.map((obj) => ({
            value: obj?.KODEUNIT,
            label: obj?.NAMAUNIT,
            name: obj?.NAMAUNIT,
            jenis3: obj?.JENIS3,
            registrationType: registrationType,
          }));
          setSelectorAntrian([pilihanNull, ...selectorTemp]);
          setLoadingAntrian(false);
        } else {
          setSelectorAntrian([]);
          setLoadingAntrian(false);
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  // const cekTanggalServer = () => {
  //   Axios.get(urlAPI + "/public/regonline/cektanggal")
  //     .then((response) => {
  //       setTanggalServer(response?.data?.result[0]?.Tanggal);
  //       setTanggalClient(moment(new Date()).format("YYYY-MM-DD"));

  //       if (
  //         moment(new Date()).format("YYYY-MM-DD") !==
  //         response?.data?.result[0]?.Tanggal
  //       ) {
  //         setMessageState("Tanggal Perangkat Tidak Sesuai Dengan Server");
  //         setShowFailed(true);
  //         setLoadingUnit(false);
  //       } else {
  //         setLoadingPengumuman(true);
  //         fetchCheckPengumuman();
  //       }
  //     })
  //     .catch((err) => {
  //       setMessageState(err?.response?.data?.message ?? err?.response);
  //       setShowFailed(true);
  //       setLoadingUnit(false);
  //     });
  // };

  const cekTanggalServer = () => {
    Axios.get(urlAPI + "/public/regonline/cektanggal")
      .then((response) => {
        const serverRow = response?.data?.result[0];
        setTanggalServer(serverRow?.Tanggal);
        setTanggalClient(moment(new Date()).format("YYYY-MM-DD"));

        if (moment(new Date()).format("YYYY-MM-DD") !== serverRow?.Tanggal) {
          setMessageState("Tanggal Perangkat Tidak Sesuai Dengan Server");
          setShowFailed(true);
          setLoadingUnit(false);
        } else if (isBelumBuka(dataStep1?.unit, serverRow)) {
          setMessageState(PESAN_BELUM_BUKA);
          setShowInfo(true);
          setLoadingUnit(false);
        } else {
          setLoadingPengumuman(true);
          fetchCheckPengumuman();
        }
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? err?.response);
        setShowFailed(true);
        setLoadingUnit(false);
      });
  };

  // console.log('tanggal server', tanggalServer);
  // console.log('tanggal client', tanggalClient);
  // const fetchCheckPengumuman = () => {
  //   Axios.get(
  //     urlAPI + "/public/regonline/checkpengumuman?sbu=" + dataStep1?.sbu
  //   )
  //     .then((response) => {
  //       setLoadingPengumuman(false);
  //       if (response?.data?.result?.length > 0) {
  //         setDataPengumuman({
  //           ...response?.data?.result[0],
  //         });
  //         setActiveStep(activeStep + 1);
  //         myRef.current.scrollIntoView();
  //         setOpenPengumuman(true);
  //       } else {
  //         setOpenPengumuman(false);
  //         setDataPengumuman({});
  //         setActiveStep(activeStep + 1);
  //         myRef.current.scrollIntoView();
  //       }
  //     })
  //     .catch((err) => {
  //       setMessageState(err?.response?.data?.message ?? err?.response);
  //       setShowFailed(true);
  //       setLoadingUnit(false);
  //     });
  // };

const fetchCheckPengumuman = () => {
  if (!["REGULER", "ABYAKTA", "EKSKLUSIF"].includes(dataStep1?.registrationType)) {
    setOpenPengumuman(false);
    setDataPengumuman({});
    setActiveStep(activeStep + 1);
    myRef.current?.scrollIntoView();
    return;
  }

  setLoadingPengumuman(true);
  Axios.get(`${urlAPI}/public/regonline/checkpengumuman?sbu=${dataStep1?.sbu}`)
    .then((response) => {
      setLoadingPengumuman(false);
      const result = response?.data?.result;
      if (Array.isArray(result) && result.length > 0) {
        setDataPengumuman({ ...result[0] });
        setOpenPengumuman(true);
      } else {
        setOpenPengumuman(false);
        setDataPengumuman({});
      }
      setActiveStep(activeStep + 1);
      myRef.current?.scrollIntoView();
    })
    .catch((err) => {
      setMessageState(err?.response?.data?.message ?? err?.response);
      setShowFailed(true);
      setLoadingUnit(false);
    });
};

  /*eslint-disable */
  useEffect(() => {
    if (
      dataStep1?.sbu !== null &&
      dataStep1?.unit !== null &&
      dataStep1?.date !== null &&
      dataStep1?.rs !== null &&
      dataStep1?.registrationType !== null &&
      moment(dataStep1.date).isValid()
    ) {
      setLoadingUnit(true);
      fetchSelectorUnit(dataStep1?.sbu, registrationType);
      fetchSelectorUnitAntrian(dataStep1?.sbu);
    }
  }, [dataStep1?.sbu, dataStep1?.unit, dataStep1?.date]);
  
  useEffect(() => {
    if (!showModal) {
      setActiveStep(1);
      // setDataStep1(initStep1);
      setDataStep2(initStep2);
      setDataStep3(initStep3);
      setDataStep4(initStep4);
      setDataBPJS(initDataBPJS);
      setSuccessState(initSuccessState);
    }
  }, [showModal]);

  useEffect(() => {
    if (window.innerWidth < 768 && sliderRef.current) {
      const glide = new Glide(sliderRef.current, {
        type: "carousel",
        perView: 1,
        autoplay: 3000,
        hoverpause: true,
      });

      glide.mount();
      return () => glide.destroy();
    }
  }, []);

  useEffect(() => {
    const savedSBU = localStorage?.getItem("selectedSBU");
    if (savedSBU) {
      const parsedSBU = JSON.parse(savedSBU);
      setSelectedSBU(parsedSBU);
      setDataStep1((prev) => ({
        ...prev,
        sbu: parsedSBU.value,
        sbuname: parsedSBU.label,
      }));
    }
  }, []);

  useEffect(() => {
  const searchParams = new URLSearchParams(location.search);
  const menuQuery = searchParams.get("menu");
  const sbuQuery = searchParams.get("sbu"); // tambahkan ini

  if (menuQuery === "kuisioner") {
    const kuisionerMenu = menuLayanan.find(
      (menu) => menu.label === "Kuisioner Pelanggan"
    );
    if (kuisionerMenu) {
      setSelectedMenu(kuisionerMenu);
      setShowModal(true);
      if (sbuQuery) {
        setDataStep1((prev) => ({ ...prev, sbu: sbuQuery })); // atau state baru
      }
    }
  }
}, [location.search]);

//   useEffect(() => {
//     if (selectedMenu?.label === "Daftar Online") {
//         setShowRegistrationModal(true);
//         setShowUnitDateModal(true);

//         // Jika dataStep1 valid, panggil fetchJadwalDokter
//         if (
//             dataStep1?.sbu &&
//             dataStep1?.unit &&
//             dataStep1?.date &&
//             moment(dataStep1.date).isValid()
//         ) {
//             fetchJadwalDokter();
//         }
//     }
// }, [selectedMenu]);

// useEffect(() => {
//   if (selectedMenu?.label === "Daftar Online") {
//       setShowUnitDateModal(true);
//   }
// }, [selectedMenu]);

useEffect(() => {
  if (selectedMenu?.label === "Daftar Online") {
    setShowExclusiveModal(true); 
    setShowUnitDateModal(false);
  }
}, [selectedMenu]);


  useEffect(() => {
    if (selectedMenu?.label === "Jadwal Dokter") {
      setFilterJadwal({
        sbu: "defaultSBUValue",
        poli: null,
        namapoli: "",
        jadwalType: null,
      });
      setDataDokter({ count: 0, rows: [] });
      setShowJadwal(false);
    }
  }, [selectedMenu]);  

  // useEffect(() => {
  //   const params = new URLSearchParams(window.location.search);
  //   const sbuParam = params.get('sbu');
  //   const menuParam = params.get('menu');
  //   if (sbuParam === 'RSPG' && menuParam === 'kuisioner') {
  //     const rspgData = selectorSBU.find(item => item.value === 'RSPG');

  //     if (rspgData) {
  //       setSelectedSBU(rspgData);
  //       setDataStep1(prev => ({
  //         ...prev,
  //         sbu: rspgData.value,
  //         sbuname: rspgData.label
  //       }));
  //       setShowModel(true);
  //       const kuisionerMenu = menuLayanan.find(item => item.label === "Kuisioner Pelanggan");
  //       if (kuisionerMenu) {
  //         setTimeout(() => {
  //           setSelectedMenu(kuisionerMenu);
  //           setShowModal(true);
  //         }, 600);
  //       }
  //     }
  //   }
  // }, []);
  useEffect(() => {
  const params = new URLSearchParams(window.location.search);
  const sbuParam = params.get('sbu');
  const menuParam = params.get('menu');

  if (sbuParam && menuParam === 'kuisioner') {
    const sbuData = selectorSBU.find(item => item.value === sbuParam);

    if (sbuData) {
      setSelectedSBU(sbuData);
      setDataStep1(prev => ({
        ...prev,
        sbu: sbuData.value,
        sbuname: sbuData.label
      }));
      setShowModel(true);
      const kuisionerMenu = menuLayanan.find(item => item.label === "Kuisioner Pelanggan");
      if (kuisionerMenu) {
        setTimeout(() => {
          setSelectedMenu(kuisionerMenu);
          setShowModal(true);
        }, 600);
      }
    } else {
      console.warn("SBU dari QR tidak dikenali:", sbuParam);
    }
  }
}, []);

  /*eslint-enable */

  const [loadingSave, setLoadingSave] = useState(false);

  const SPECIAL_QUOTA_UNITS = ["G16", "G17", "G18"];
  const KUOTA_ONLY_UNITS = ["A62", "P48"];
  const isSpecialQuotaUnit = SPECIAL_QUOTA_UNITS.includes(dataStep1?.unit);
  const isKuotaOnlyUnit = KUOTA_ONLY_UNITS.includes(dataStep1?.unit);

  const CONTACT_PHONE_BY_SBU = {
    RSPG: "081331706002",
    DRIYO: "081235737711",
    GRAHU: "082131177207",
  };
  const getSpecialQuotaExtraNote = () => {
    if (!isSpecialQuotaUnit) return null;
    const phone = CONTACT_PHONE_BY_SBU[dataStep1?.sbu];
    return (
      "Pembatalan pendaftaran hanya dapat dilakukan minimal 2 jam sebelum jadwal periksa,y " +
      (phone
        ? `Untuk pembatalan silahkan konfirmasi ke HP Pendaftaran: ${phone}`
        : "Untuk pembatalan atau konfirmasi, silahkan hubungi bagian Pendaftaran rumah sakit tujuan Anda.")
    );
  };

  // 
  
  const cekKuota = () => {
  const needRiwayatCheck =
    dataStep3?.jaminan === "bpjs" &&
    RIWAYAT_CHECK_UNITS.includes(dataStep1?.unit);

  const proceedAfterRiwayat = () => {
    Axios.get(
      urlAPI +
        "/public/regonline/cekKuota?params=" +
        JSON.stringify({
          idjadwal: dataStep2?.idjadwal,
          kodeunit: dataStep1?.unit,
          tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
          kodedokter: dataStep2?.kodedokter,
          jam: dataStep2?.jam,
          jaminan: dataStep3?.jaminan,
        })
    )
      .then((response) => {
        const row = response?.data?.result?.[0] ?? {};
        const kuotaUmum = Number(
          row?.KUOTAUMUM ?? row?.kuotaUmum ?? row?.KUOTANONJKN ?? row?.kuotaNonJkn ?? 0
        );
        const kuotaBpjs = Number(
          row?.KUOTABPJS ?? row?.kuotaBpjs ?? row?.KUOTAJKN ?? row?.kuotaJkn ?? 0
        );

        if (isSpecialQuotaUnit) {
          if (dataStep1?.unit === "G16" && dataStep3?.jaminan === "bpjs") {
            setMessageState("Poli G16 tidak menerima jaminan BPJS. Silakan pilih Umum/Asuransi.");
            setShowInfo(true);
            setLoadingUnit(false);
            return;
          }

          if (dataStep3?.jaminan === "bpjs") {
            if (kuotaBpjs <= 0) {
              setMessageState("Maaf Kuota Sudah Penuh");
              setShowFailed(true);
              setLoadingUnit(false);
              return;
            }
          } else {
            if (kuotaUmum <= 0) {
              setMessageState("Maaf Kuota Sudah Penuh");
              setShowFailed(true);
              setLoadingUnit(false);
              return;
            }
          }
        } else if (isKuotaOnlyUnit) {
          const currentQuota = Number(row?.KUOTA ?? 0);
          if (currentQuota <= 0) {
            setMessageState("Maaf Kuota Sudah Penuh");
            setShowFailed(true);
            setLoadingUnit(false);
            return;
          }
        } else {
          const currentQuota = Number(row?.KUOTA ?? 0);
          if (row?.SELISIH <= 0 && currentQuota !== 0) {
            setMessageState("Maaf Kuota Sudah Habis");
            setShowFailed(true);
            setLoadingUnit(false);
            return;
          }
        }

        const kuotaTerpakai = dataStep3?.jaminan === "bpjs" ? kuotaBpjs : kuotaUmum;
          setDataBPJS((prev) => ({ ...prev, kuota: kuotaTerpakai }));

        setLoadingSave(true);
        setMessageState("");
        setShowConfirmation(false);
        setConfirmationFrom(null);
        handleSave(kuotaTerpakai);
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? "Terjadi kesalahan saat memeriksa kuota.");
        setShowFailed(true);
        setLoadingUnit(false);
        setLoadingSave(false);
      });
  };

  if (needRiwayatCheck) {
    setLoadingUnit(true);
    cekRiwayatRegister()
      .then((response) => {
        if (response?.data?.blocked === true) {
          setMessageState(response?.data?.message);
          setShowFailed(true);
          setLoadingUnit(false);
          setLoadingSave(false);
          return;
        }
        proceedAfterRiwayat();
      })
      .catch((err) => {
        setMessageState(err?.response?.data?.message ?? "Gagal memeriksa riwayat pendaftaran.");
        setShowFailed(true);
        setLoadingUnit(false);
        setLoadingSave(false);
      });
  } else {
    proceedAfterRiwayat();
  }
}; 

const cekRiwayatRegister = () => {
  return Axios.get(
    urlAPI +
      "/public/regonline/cekRiwayatRegister?params=" +
      JSON.stringify({
        norm: dataStep3?.norm,
        kodeunit: dataStep1?.unit,
        tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
      })
  );
};

  const handleSave = (kuotaOverride) => {
    Axios.post(urlAPI + "/public/regonline/tambah", {
      isBPJS:
        dataStep3?.jaminan === "bpjs" && unitJenis3 !== "PPK1" ? true : false,
      sbu: dataStep1?.sbu,
      kuota: kuotaOverride ?? dataBPJS?.kuota,
      dataSIRS: {
        kodeunit: dataStep1?.unit,
        tanggal: moment(dataStep1?.date).format("YYYY-MM-DD"),
        kodedokter: dataStep2?.kodedokter,
        ruang: dataStep2?.ruang,
        jam: dataStep2?.jam,
        sesi: dataStep2?.sesi,
        norm: dataStep3?.norm,
        prenobooking: moment(dataStep1?.date).format("YYYYMMDD"),
        tlp: dataStep4?.tlp,
        noasuransi: dataStep3?.noasuransi,
        jaminan: dataStep3?.jaminan,
        noktp: dataStep3?.noktp,
        nama: dataStep3?.nama,
        tgllahir: moment(dataStep3?.tgllahir).format("YYYY-MM-DD"),
        kelamin: dataStep3?.kelamin,
        alamat: dataStep3?.alamat,
        nonBpjs: dataStep4?.nonBpjs,
        paketmcu: dataStep3?.paketmcu,
        
      },
      dataBPJS:
        dataStep3?.jaminan !== "bpjs" && unitJenis3 !== "PPK1"
          ? null
          : {
              jenispasien: "JKN",
              nomorkartu: noBPJS.trim(),
              nik:
                dataRujukan[0]?.peserta?.nik === null
                  ? dataStep3?.noktp.trim()
                  : dataRujukan[0]?.peserta?.nik.trim(),
              nohp:
                dataRujukan[0]?.peserta?.mr?.noTelepon !== "" &&
                dataRujukan[0]?.peserta?.mr?.noTelepon !== null
                  ? dataRujukan[0]?.peserta?.mr?.noTelepon
                  : dataStep4?.tlp.trim(),
              kodepoli: dataRujukan.length > 0 ? dataStep2?.kodeunitbpjs : null,
              namapoli:
                dataRujukan.length > 0
                  ? dataRujukan[0]?.poliRujukan?.nama
                  : null,
              pasienbaru: 0,
              norm: dataStep3?.norm,
              tanggalperiksa: moment(dataStep1?.date).format("YYYY-MM-DD"),
              kodedokter: dataStep2?.kodedokterbpjs,
              namadokter: dataStep2?.namadokter,
              jampraktek:
                dataStep2?.jam === null
                  ? "00:00-23:59"
                  : dataStep2?.jam.replaceAll(" ", ""),

              jeniskunjungan:
                SEP === 0 || SEP === "0"
                  ? 1
                  : dataStep2?.kodeunitbpjs ===
                    dataRujukan[0]?.poliRujukan?.kode
                  ? suratKontrol[0]?.noSuratKontrol !== ""
                    ? 3
                    : 2
                  : 2,
              nomorreferensi:
                SEP === 0 || SEP === "0"
                  ? dataRujukan[0]?.noKunjungan
                  : dataStep2?.kodeunitbpjs ===
                    dataRujukan[0]?.poliRujukan?.kode
                  ? suratKontrol[0]?.noSuratKontrol !== ""
                    ? suratKontrol[0]?.noSuratKontrol
                    : "1302R" +
                      moment(dataStep1?.date).format("YYYYMMDD") +
                      dataStep3?.norm
                  : "1302R" +
                    moment(dataStep1?.date).format("YYYYMMDD") +
                    dataStep3?.norm,
              estimasidilayani:
                dataStep2?.jam.length === 13
                  ? moment(
                      dataStep1?.date +
                        " " +
                        dataStep2?.jam.substring(0, 5) +
                        ":00"
                    ).valueOf()
                  : moment(dataStep1?.date + " 00:00:00").valueOf(),
              keterangan:
                "Peserta harap 30 menit lebih awal guna pencatatan administrasi.",

              kodebooking: null,
              sisakuotajkn: null,
              kuotajkn: null,
              sisakuotanonjkn: null,
              kuotanonjkn: null,
              nomorantrean: null,
              angkaantrean: null,
            },
    })
      .then((response) => {
        if (response?.data?.status === false) {
          setMessageState(response?.data?.message);
          setShowFailed(true);
          setLoadingSave(false);
          return;
        }

        const responseData = response?.data?.result;
        // setSuccessState({
        //   sbuname: dataStep1?.sbuname,
        //   unitname: dataStep1?.unitname,
        //   doktername: dataStep2?.namadokter,
        //   tanggal: dataStep1?.date,
        //   jam: dataStep2?.jam,
        //   nobooking: responseData?.nobooking,
        //   antrian: responseData?.antrian,
        //   rs: dataStep1?.rs,
        //   ramayanaNonPG: responseData?.ramayanaNonPG,
        //   jaminan: dataStep3?.jaminan,
        //   nama_pasien: dataStep3?.nama,
        // });
        setDataStep1(initStep1);
        setDataStep2(initStep2);
        setDataStep3(initStep2);
        setLoadingSave(false);
        if (response?.data?.kirimbpjs === "sukses") {
          history.push("/ticket/" + responseData?.nobooking + "/green"); //tampilan sukses pindah ke /src/ticket/index
        } else if (response?.data?.kirimbpjs === "gagal") {
          history.push("/ticket/" + responseData?.nobooking + "/red"); //tampilan sukses pindah ke /src/ticket/index
        } else {
          history.push("/ticket/" + responseData?.nobooking + "/blue"); //tampilan sukses pindah ke /src/ticket/index
        }
        // setActiveStep(5);
        myRef.current.scrollIntoView();
      })
      .catch((err) => {
        setMessageState(
          err?.response?.data?.message ?? err?.response + " on save"
        );
        setShowFailed(true);
        setLoadingSave(false);
      });
  };

  return (
    <>
      {/* <FloatingWhatsApp
        zIndex={9999}
        phone={dataStep1?.sbu === "DRIYO" ? "6281331518197" : "#"}
        popupMessage={"Hallo, Ada yang bisa kami bantu?"}
      /> */}
      <ModalInformasi
        show={openInformasi}
        data={dataInformasi}
        handleClose={() => {
          setOpenInformasi(false);
          setDataInformasi({});
        }}
      />
      <ModalPengumuman
        show={openPengumuman}
        data={dataPengumuman}
        handleClose={() => {
          setDataPengumuman({});
          setOpenPengumuman(false);
        }}
      />
      <FailedAlert
        show={showFailed}
        message={messageState}
        onConfirm={() => {
          setMessageState("");
          setShowFailed(false);
        }}
      />
      <InfoAlert
        show={showInfo}
        message={messageState}
        onConfirm={() => {
          setMessageState("");
          setShowInfo(false);
        }}
      />
      <ConfirmationAlert
        show={showConfirmation}
        message={messageState}
        extraNote={getSpecialQuotaExtraNote()}
        onConfirm={() => {
          if (confirmationFrom === "step4") {
            // setLoadingSave(true);
            setMessageState("");
            setShowConfirmation(false);
            setConfirmationFrom(null);
            //handleSave();
            cekKuota();
          } else if (confirmationFrom === "step3") {
            setMessageState("");
            setShowConfirmation(false);
            setConfirmationFrom(null);

            setActiveStep(activeStep + 1);
            myRef.current.scrollIntoView();
          }
        }}
        onCancel={() => {
          setMessageState("");
          setShowConfirmation(false);
          setConfirmationFrom(null);
        }}
      />
    <div style={{ padding: "4px" }}>
    <Row className="g-0 justify-center">
    <Col lg={4} md={4} sm={12} className="p-3">
      <Card style={{ width: "100%", height: "100%", borderRadius: "18px" }}>
        <Card.Body style={style?.CardWelcomeMedia} className="p-2">

{/* Tampilan untuk HP */}
<div
  className="d-flex align-items-center d-md-none"
  style={{
    width: "100%",
    gap: "12px",
    padding: "10px 12px",
  }}
>
  {/* LOGO */}
  <img
    src="assets/img/logopgm123.png"
    alt="logo"
    style={{
      width: "70px",
      height: "50px",
      objectFit: "contain",
      flexShrink: 0,
    }}
  />

  {/* TEXT */}
  <div
    className="d-flex flex-column justify-content-center"
    style={{ lineHeight: "1.2" }}
  >
    <h1
      style={{
        fontSize: "16px",
        fontWeight: "700",
        margin: "0",
        color: "#111",
        letterSpacing: "0.3px",
      }}
    >
      PETRO GRAHA MEDIKA
    </h1>

    <span
      style={{
        fontSize: "12px",
        color: "#56ab2f",
        fontWeight: "600",
        marginTop: "2px",
      }}
    >
      Sahabat Menuju Sehat
    </span>

    <span
      style={{
        fontSize: "11px",
        color: "#666",
        marginTop: "4px",
        fontWeight: "500",
      }}
    >
      RS PETROKIMIA GRESIK GROUP
    </span>
  </div>
</div>

        {/* Tampilan untuk Desktop */}
          <div className="text-center d-none d-md-block">
            <img 
              src="assets/img/logopgm.png" 
              alt="gambar" 
              className="w-75"
            />
          </div>
        </Card.Body>
      </Card>
    </Col>


    <Col className="d-none d-md-block" lg={8} md={8}>
      <Card style={style?.CardWelcome}>
        <Card.Body style={style?.CardWelcomeMedia} className="p-2">
          <Row className="g-0">
            <Col lg={8} md={8}>
              <h1 className="mb-1">
                <strong>Selamat Datang!</strong>
              </h1>
              <h4 className="mb-1">Registrasi Rawat Jalan Online</h4>
              <p className="mb-0">
                Silahkan isi dan pilih data di bawah ini untuk melakukan registrasi unit rawat jalan secara online.
              </p>
            </Col>
            <Col lg={4} md={4} className="text-center">
              <img
                src="assets/img/welcome-img.svg"
                alt="gambar"
                className="w-100"
              />
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </Col>
  </Row>
  
  <Container>
      <style>
  {`
    /* Header Accordion */
    .custom-accordion .accordion-button {
      background: linear-gradient(135deg, #56ab2f, #a8e063) !important;
      color: #fff !important;
      border: none !important;
      border-radius: 12px !important;
      padding: 15px 20px !important;
      font-weight: 700 !important;
      transition: all 0.3s ease !important;
    }

    /* Saat Accordion Terbuka */
    .custom-accordion .accordion-button:not(.collapsed) {
      border-bottom-left-radius: 0px !important;
      border-bottom-right-radius: 0px !important;
      box-shadow: 0 4px 12px rgba(86, 171, 47, 0.2) !important;
    }

    /* Efek Hover Header */
    .custom-accordion .accordion-button:hover {
      opacity: 0.95;
      transform: translateY(-2px);
    }

    /* Icon Panah Putih */
    .custom-accordion .accordion-button::after {
      filter: brightness(0) invert(1);
      transition: transform 0.3s ease;
    }

    /* Body Accordion */
    .custom-accordion .accordion-body {
      background: #ffffff;
      border: 1px solid #eef5ee !important;
      border-top: none !important;
      border-bottom-left-radius: 12px !important;
      border-bottom-right-radius: 12px !important;
      padding: 25px !important;
    }

    /* Menghilangkan focus ring biru */
    .accordion-button:focus {
      box-shadow: none !important;
    }

    /* Membungkus item agar bayangan terlihat */
    .custom-accordion .accordion-item {
      background: transparent !important;
      border: none !important;
      margin-bottom: 10px;
    }
  `}
</style>

      {/* ================= LIST SBU ================= */}
      <Row className="g-0 justify-content-center mt-2">
        {selectorSBU.map((obj, index) => (
          <Col key={index} xs={12} sm={6} md={4} lg={4} className="p-2">

            {/* DESKTOP */}
            <Card
              className="text-center shadow-sm h-100 d-none d-md-flex border-0"
              role="button"
              style={{
                borderRadius: "14px",
                transition: "all 0.25s ease",
                transform: hoverIndex === index ? "scale(1.03)" : "scale(1)",
                boxShadow:
                  hoverIndex === index
                    ? "0 10px 25px rgba(86,171,47,0.25)"
                    : "0 3px 8px rgba(0,0,0,0.05)",
                padding: "16px",
                background: "linear-gradient(180deg, #ffffff, #f9fdf8)"
              }}
              onMouseEnter={() => setHoverIndex(index)}
              onMouseLeave={() => setHoverIndex(null)}
              onClick={() => {
                handleSelect(obj);
                setDataStep1({ ...dataStep1, sbu: obj.value });
                // fetchSelectorUnit(obj.value);
                setShowModel(true);
              }}
            >
              <Card.Img
                src={obj.img}
                alt={obj.label}
                style={{
                  width: "100%",
                  height: "220px",
                  objectFit: "cover",
                  borderRadius: "10px"
                }}
              />

              <Card.Body>
                <Card.Text className="fw-bold" style={{ fontSize: "17px" }}>
                  {obj.label}
                </Card.Text>
              </Card.Body>
            </Card>

            {/* MOBILE */}
            <Card
              className="d-md-none shadow-sm border-0"
              role="button"
              style={{
                borderRadius: "12px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                padding: "10px",
                background: "#fff"
              }}
              onClick={() => {
                handleSelect(obj);
                setDataStep1({ ...dataStep1, sbu: obj.value });
                // fetchSelectorUnit(obj.value);
                setShowModel(true);
              }}
            >
              <img
                src={obj.img}
                alt={obj.label}
                style={{
                  width: "80px",
                  height: "80px",
                  objectFit: "cover",
                  borderRadius: "10px",
                  marginRight: "12px"
                }}
              />

              <div>
                <div className="fw-bold" style={{ fontSize: "14px" }}>
                  {obj.label}
                </div>
              </div>
            </Card>

          </Col>
        ))}
      </Row>

      {/* ================= MODAL ================= */}
      {showModel && selectedSBU && (
        <Modal
          show={showModel}
          onHide={() => setShowModel(false)}
          size="xl"
          centered
          style={{ backdropFilter: "blur(8px)", backgroundColor: "rgba(0,0,0,0.4)" }}
        >

          {/* HEADER */}
          <Modal.Header
            closeButton
            style={{
              background: greenGradient,
              color: "#fff",
              border: "none"
            }}
          >
            <Modal.Title className="w-100 text-center fw-bold">
              {selectedSBU.label}
            </Modal.Title>
          </Modal.Header>

          {/* BODY */}
          <Modal.Body style={{ background: "#f4f7f5" }}>

            {/* PROFIL */}
            <Card
              className="border-0 mb-4"
              style={{
                borderRadius: "16px",
                background: "#fff",
                boxShadow: "0 8px 20px rgba(0,0,0,0.05)"
              }}
            >
              <Card.Body className="text-center">

                {/* IMAGE */}
                <img
                  src={selectedSBU.img}
                  alt=""
                  style={{
                    width: "100%",
                    maxWidth: "360px",
                    height: "200px",
                    objectFit: "cover",
                    borderRadius: "12px",
                    boxShadow: "0 10px 25px rgba(86,171,47,0.2)"
                  }}
                />

                {/* ACCORDION */}
                <Accordion className="mt-4 custom-accordion">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <span style={{ fontSize: '1.05rem', letterSpacing: '0.3px' }}>
                        🏥 Profil Rumah Sakit
                      </span>
                    </Accordion.Header>
                    <Accordion.Body>
                      <p style={{
                        textAlign: "justify",
                        color: "#555",
                        lineHeight: "1.8",
                        fontSize: "0.95rem",
                        marginBottom: "25px"
                      }}>
                        {selectedSBU.profile}
                      </p>

                      <div className="text-center">
                        <a
                          href={selectedSBU.location}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="btn"
                          style={{
                            background: "linear-gradient(135deg, #56ab2f, #2e7d32)",
                            color: "#fff",
                            padding: "12px 30px",
                            borderRadius: "50px",
                            textDecoration: "none",
                            fontWeight: "600",
                            fontSize: "14px",
                            display: "inline-flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "0 6px 20px rgba(46, 125, 50, 0.25)",
                            transition: "all 0.3s ease"
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.transform = "scale(1.05)";
                            e.currentTarget.style.boxShadow = "0 8px 25px rgba(46, 125, 50, 0.35)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.transform = "scale(1)";
                            e.currentTarget.style.boxShadow = "0 6px 20px rgba(46, 125, 50, 0.25)";
                          }}
                        >
                          <span>📍</span> Lihat Lokasi
                        </a>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </Card.Body>
            </Card>

            {/* MENU LAYANAN */}
            <Card
  className="border-0"
  style={{
    borderRadius: "16px",
    background: greenSoft,
    padding: "16px"
  }}
>
  <Row className="row-cols-2 row-cols-md-3 g-4">

    {menuLayanan.map((obj, index) => (
      <Col key={index} className="d-flex">
        <Card
          role="button"
          onClick={() => handleOpenModal(obj)}
          className="text-center border-0 h-100 w-100"
          style={{
            borderRadius: "14px",
            padding: "16px",
            transition: "all 0.25s ease",
            boxShadow: "0 3px 10px rgba(0,0,0,0.06)"
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-6px)";
            e.currentTarget.style.boxShadow =
              "0 12px 25px rgba(86,171,47,0.3)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow =
              "0 3px 10px rgba(0,0,0,0.06)";
          }}
        >
          <Card.Body className="d-flex flex-column justify-content-center align-items-center">

            {/* ICON */}
            <div
              style={{
                width: "65px",
                height: "65px",
                borderRadius: "50%",
                marginBottom: "10px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: greenGradient,
                color: "#fff",
                boxShadow: "0 6px 15px rgba(86,171,47,0.3)"
              }}
            >
              {obj.icon}
            </div>

            {/* LABEL */}
            <div
              className="fw-bold text-center"
              style={{
                fontSize: "14px",
                color: greenDark,
                minHeight: "40px"
              }}
            >
              {obj.label}
            </div>

          </Card.Body>
        </Card>
      </Col>
    ))}

  </Row>
</Card>

          </Modal.Body>
        </Modal>
      )}
    </Container>

<Modal
  show={showExclusiveModal}
  onHide={() => {
    setShowExclusiveModal(false);
    setShowUnitDateModal(false);
    setShowModal(false);
    setSelectedMenu(null);
    setActiveStep(1);
    setDataStep1(dataStep1);
  }}
  centered
  size="lg"
  className="registration-modal"
  style={{ backdropFilter: "blur(8px)", backgroundColor: "rgba(0,0,0,0.4)" }}
>
  <Modal.Header closeButton className="border-0 pb-0 pt-4 px-4">
    <Modal.Title className="w-100 text-center">
      <div style={{ fontWeight: "800", fontSize: "24px", color: "#1a2a32", letterSpacing: "-0.3px" }}>
        Pilih Jenis Layanan
      </div>
    </Modal.Title>
  </Modal.Header>

  <Modal.Body className="d-flex flex-column gap-3 pt-2 pb-5 px-4">
    {getRegistrationOptions().map((option, index) => {
      const colorMap = {
        PRIORITAS: { 
          gradient: "linear-gradient(135deg, #fff6d6 0%, #f5e6a3 100%)",
          border: "#d4af37", 
          accent: "#b8860b",
        },
        ABYAKTA: { 
          gradient: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
          border: "#0077b6", 
          accent: "#023e8a",
        },
        REGULER: { 
          gradient: "linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%)",
          border: "#56ab2f", 
          accent: "#2d6a1e",
        },
        EKSKLUSIF: { 
          gradient: "linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%)",
          border: "#6a4c93", 
          accent: "#4a3070",
        },
      };

      const style = colorMap[option.value] || {
        gradient: "linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)",
        border: "#adb5bd",
        accent: "#6c757d",
        icon: "📌"
      };

      const descriptionMapRSPG = {
        PRIORITAS: [
          { label: "Tempat Layanan", value: "Poli Prioritas Abyakta" },
          { label: "Jam Layanan", value: "By Appointment (Sesuai Jadwal Praktek Dokter)" },
          { label: "Layanan Antar Obat", value: "FREE", highlight: true },
          { label: "Fasilitas Tambahan", value: "Didampingi oleh Personal Assistant" },
          { label: "Penjaminan", value: "Tunai" }
        ],
        EKSKLUSIF: [
          { label: "Tempat Layanan", value: "Poli Eksklusif" },
          { label: "Jam Layanan", value: "Jadwal Poli Eksklusif" },
          { label: "Penjaminan", value: "Tunai, Asuransi, Tagihan Perusahaan" }
        ],
        ABYAKTA: [
          { label: "Tempat Layanan", value: "Poli Eksklusif Abyakta" },
          { label: "Jam Layanan", value: "Jadwal Poli Eksklusif" },
          { label: "Layanan Antar Obat", value: "FREE", highlight: true },
          { label: "Penjaminan", value: "Tunai, Tagihan Perusahaan, Asuransi sesuai Benefit", hasLink: true }
        ],
        REGULER: [
          { label: "Tempat Layanan", value: "Gedung Abhinaya dan HBC" },
          { label: "Jam Layanan", value: "Jadwal Poli Reguler" },
          { label: "Layanan Antar Obat", value: "ADA / FREE", note: "(S&K berlaku)" },
          { label: "Penjaminan", value: "BPJS, Tunai, Asuransi, Tagihan Perusahaan" }
        ],
      };

      const descriptionMapGRAHU = {
        EKSKLUSIF: [
          { label: "Tempat Layanan", value: "Poli Eksekutif Grahu" },
          { label: "Jam Layanan", value: "Jadwal Poli Eksekutif" },
          { label: "Penjaminan", value: "Tunai, Asuransi, Tagihan Perusahaan" }
        ],
        REGULER: [
          { label: "Tempat Layanan", value: "Poli Reguler Grahu" },
          { label: "Jam Layanan", value: "Jadwal Poli Reguler" },
          { label: "Penjaminan", value: "BPJS, Tunai, Asuransi, Tagihan Perusahaan" }
        ],
      };

      const items = dataStep1?.sbu === "RSPG" 
        ? descriptionMapRSPG[option.value] || []
        : dataStep1?.sbu === "GRAHU"
        ? descriptionMapGRAHU[option.value] || []
        : [];

      return (
        <div
          key={index}
          onClick={() => handleSelectRegistrationType(option.value)}
          className="registration-card"
          style={{
            cursor: "pointer",
            borderRadius: "18px",
            overflow: "hidden",
            background: "#fff",
            transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
            boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
            border: `1px solid rgba(0,0,0,0.05)`
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
            e.currentTarget.style.boxShadow = `0 16px 28px -8px ${style.border}60`;
            e.currentTarget.style.borderColor = style.border;
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
            e.currentTarget.style.boxShadow = "0 2px 8px rgba(0,0,0,0.04)";
            e.currentTarget.style.borderColor = "rgba(0,0,0,0.05)";
          }}
        >
          <div className="row g-0">
            {/* IMAGE SECTION */}
            <div className="col-md-4 position-relative img-wrapper" style={{ height: "200px", overflow: "hidden" }}>
              <img
                src={option.img}
                alt={option.label}
                className="card-img"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  transition: "transform 0.5s ease"
                }}
              />

              {/* BADGE DI FOTO */}
              <div className="badge-label" style={{ 
                background: style.border,
                position: "absolute",
                top: "12px",
                left: "12px",
                color: "#fff",
                padding: "4px 14px",
                borderRadius: "20px",
                fontSize: "10px",
                fontWeight: "800",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.2)",
                zIndex: 2
              }}>
                {option.value}
              </div>

              {/* OVERLAY GRADIENT */}
              <div className="img-overlay" style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "40%",
                background: "linear-gradient(to top, rgba(0,0,0,0.3), transparent)",
                zIndex: 1
              }} />
            </div>

            {/* CONTENT SECTION */}
            <div
              className="col-md-8 content-wrapper"
              style={{ 
                background: style.gradient,
                height: "200px"
              }}
            >
              <div className="p-4 h-100 d-flex flex-column justify-content-between">
                <div>
                  <h5 className="fw-bold mb-3 title" style={{ 
                    fontSize: "18px",
                    color: "#1a2a32",
                    letterSpacing: "-0.2px",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px"
                  }}>
                    <span style={{ fontSize: "24px" }}>{style.icon}</span>
                    {option.label}
                  </h5>

                  <div className="desc" style={{ fontSize: "12.5px", lineHeight: "1.7" }}>
                    {items.map((item, i) => (
                      <div key={i} className="desc-item" style={{ marginBottom: "6px", display: "flex", alignItems: "baseline" }}>
                        <span style={{ color: "#2c3e50" }}>
                        <strong>{item.label} :</strong>{" "}
                          <span style={item.highlight ? { color: style.accent, fontWeight: "bold" } : {}}>
                            {item.value}
                          </span>
                          {item.note && <em style={{ color: "#6c757d", fontSize: "11px" }}> {item.note}</em>}
                          {item.hasLink && (
                            <a
                              href="https://wa.me/6285138079388"
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ color: style.border, textDecoration: "underline", fontWeight: "500", marginLeft: "4px" }}
                            >
                              Konfirmasi Disini
                            </a>
                          )}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    })}
  </Modal.Body>
</Modal>

<style>
{`
  .registration-modal .modal-content {
    border-radius: 28px;
    border: none;
    overflow: hidden;
    box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.2);
  }

  .registration-modal .modal-header {
    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
  }

  .registration-modal .btn-close {
    transition: all 0.2s ease;
    opacity: 0.6;
  }

  .registration-modal .btn-close:hover {
    transform: scale(1.1);
    opacity: 1;
  }

  .registration-card {
    border-radius: 18px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .card-img {
    transition: transform 0.5s cubic-bezier(0.4, 0, 0.2, 1);
  }

  .registration-card:hover .card-img {
    transform: scale(1.06);
  }

  .registration-modal .modal-body {
    scrollbar-width: thin;
    scrollbar-color: #cbd5e0 #f1f5f9;
  }

  .registration-modal .modal-body::-webkit-scrollbar {
    width: 5px;
  }

  .registration-modal .modal-body::-webkit-scrollbar-track {
    background: #f1f5f9;
    border-radius: 10px;
  }

  .registration-modal .modal-body::-webkit-scrollbar-thumb {
    background: #cbd5e0;
    border-radius: 10px;
  }

  .registration-modal .modal-body::-webkit-scrollbar-thumb:hover {
    background: #94a3b8;
  }
`}
</style>

<Row className="d-block d-md-none mt-3">
  <Col sm={12}>
    <Card className="shadow-lg border-0 rounded-100">
      <Card.Body>
        <div className="glide" ref={sliderRef}>
          <div className="glide__track" data-glide-el="track">
            <ul className="glide__slides">
              <li className="glide__slide">
                <img src="assets/img/flyer1.png" alt="Slide 1" className="w-100 slider-img" />
              </li>
              <li className="glide__slide">
                <img src="assets/img/flyer2.png" alt="Slide 2" className="w-100 slider-img" />
              </li>
              <li className="glide__slide">
                <img src="assets/img/flyer3.png" alt="Slide 3" className="w-100 slider-img" />
              </li>
            </ul>
          </div>
          <div className="glide__arrows" data-glide-el="controls">
            <button className="glide__arrow glide__arrow--left" data-glide-dir="<">‹</button>
            <button className="glide__arrow glide__arrow--right" data-glide-dir=">">›</button>
          </div>
        </div>
      </Card.Body>
    </Card>
  </Col>
</Row>

<Container className="py-4">
  <Modal show={showModal} onHide={handleCloseModal} size="lg" centered>
    <Modal.Header closeButton>
      <Modal.Title style={{ color: "#2e7d32", fontWeight: "bold" }}>{selectedMenu?.label}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      {selectedMenu?.label === "Daftar Online" &&                   
        <Card style={{ ...style.Card, overflow: "visible" }} ref={myRef}>
          {loadingSave ? (
            <Card.Body>
              <br />
              <Center>
                <h3 style={{ color: "#2e7d32" }}>Sedang Menyimpan, Harap Tunggu...</h3>
              </Center>
            </Card.Body>
          ) : (
            <Card.Body>
              {activeStep === 1 && registrationType ? (
                <Step1Page
                  dataStep1={dataStep1}
                  setDataStep1={setDataStep1}
                      selectorSBU={selectorSBU}
                      registrationType={registrationType}
                      selectorRS={selectorRS}
                      fetchSelectorUnit={(event) => {
                        setLoadingUnit(true);
                        fetchSelectorUnit(event, registrationType, setDataStep1);
                      }}
                      fetchInformasiSBU={fetchInformasiSBU}
                      selectorUnit={selectorUnit}
                      loadingUnit={loadingUnit}
                      handleNext={() => {
                        cekTanggalServer();
                        // setLoadingPengumuman(true);
                        // fetchCheckPengumuman();
                      }}
                      setUnitJenis3={setUnitJenis3}
                      // loadingPengumuman={loadingPengumuman}
                    />
                  ) : activeStep === 2 ? (
                    <Step2Page
                      dataStep1={dataStep1}
                      setDataStep1={setDataStep1}
                      selectorSBU={selectorSBU}
                      registrationType={registrationType}
                      selectorRS={selectorRS}
                      fetchSelectorUnit={(event) => {
                        setLoadingUnit(true);
                        fetchSelectorUnit(event, registrationType, setDataStep1);
                      }}
                      selectorUnit={selectorUnit}
                      loadingUnit={loadingUnit}
                      dataStep2={dataStep2}
                      setDataStep2={setDataStep2}
                      setMessageState={setMessageState}
                      setShowFailed={setShowFailed}
                      setShowInfo={setShowInfo}
                      handleNext={() => {
                        if (dataStep1.rs === "Pernah") {
                          setActiveStep(activeStep + 1);
                          myRef.current.scrollIntoView();
                        } else if (dataStep1.rs === "Belum") {
                          setActiveStep(6);
                          myRef.current.scrollIntoView();
                        }
                      }}
                      setLoadingUnit={setLoadingUnit}
                      initStep2={initStep2}
                      dataBPJS={dataBPJS}
                      setDataBPJS={setDataBPJS}
                      handlePrev={() => {
                        setActiveStep(activeStep - 1);
                        myRef.current.scrollIntoView();
                      }}
                      setUnitJenis3={setUnitJenis3}
                    />
                  ) : activeStep === 3 ? (
                    <Step3Page
                      dataStep1={dataStep1}
                      dataStep2={dataStep2}
                      dataStep3={dataStep3}
                      setDataStep3={setDataStep3}
                      initStep3={initStep3}
                      setMessageState={setMessageState}
                      setShowFailed={setShowFailed}
                      handlePrev={() => {
                        setActiveStep(activeStep - 1);
                        myRef.current.scrollIntoView();
                        setActiveStep(2);
                        myRef.current.scrollIntoView();
                      }}
                      handleNext={() => {
                        if (
                          dataStep3?.jaminan === "bpjs" &&
                          dataRujukan[0]?.poliRujukan?.kode !==
                            dataStep2?.kodeunitbpjs
                        ) {
                          setMessageState(
                            "Poli yang Anda pilih berbeda dengan poli rujukan Anda, Apakah anda yakin melanjutkan pendaftaran?"
                          );
                          setShowConfirmation(true);
                          setConfirmationFrom("step3");
                        } else {
                          setActiveStep(activeStep + 1);
                          myRef.current.scrollIntoView();
                        }
                        // setActiveStep(4);
                        // myRef.current.scrollIntoView();
                      }}
                      dataBPJS={dataBPJS}
                      dataRujukan={dataRujukan}
                      setDataRujukan={setDataRujukan}
                      noBPJS={noBPJS}
                      setNoBPJS={setNoBPJS}
                      unitJenis3={unitJenis3}
                      setSEP={setSEP}
                      SEP={SEP}
                      setSuratKontrol={setSuratKontrol}
                      suratKontrol={suratKontrol}
                    />
                  ) : activeStep === 4 ? (
                    <Step4Page
                      dataStep1={dataStep1}
                      dataStep2={dataStep2}
                      dataStep3={dataStep3}
                      dataStep4={dataStep4}
                      setDataStep4={setDataStep4}
                      dataRujukan={dataRujukan}
                      handlePrev={() => {
                        setActiveStep(activeStep - 2);
                        myRef.current.scrollIntoView();
                      }}
                      handleSave={() => {
                        myRef.current.scrollIntoView();
                        setMessageState(
                          "Apakah anda yakin data sudah benar dan melakukan registrasi online? "
                        );
                        setShowConfirmation(true);
                        setConfirmationFrom("step4");
                      }}
                      loadingSave={loadingSave}
                      setSEP={setSEP}
                      SEP={SEP}
                    />
                  ) : activeStep === 5 ? (
                    <SuccessPage
                      dataStep1={dataStep1}
                      successState={successState}
                      handleRegAgain={() => {
                        myRef.current.scrollIntoView();
                        setSuccessState(initSuccessState);
                        setActiveStep(1);
                      }}
                    />
                  ) : activeStep === 6 ? (
                    <Step6Page
                      dataStep1={dataStep1}
                      dataStep2={dataStep2}
                      dataStep3={dataStep3}
                      dataStep4={dataStep4}
                      setDataStep3={setDataStep3}
                      setDataStep4={setDataStep4}
                      handlePrev={() => {
                        setActiveStep(2);
                        myRef.current.scrollIntoView();
                      }}
                      handleNext={() => {
                        setActiveStep(4);
                        myRef.current.scrollIntoView();
                      }}
                    />
                  ) : (
                    <></>
                  )}
                </Card.Body>
              )}
            </Card>}

          {selectedMenu?.label === "Riwayat Kunjungan" &&               
            <PelangganSection
              filterRiwayat={filterRiwayat}
              setFilterRiwayat={setFilterRiwayat}
              selectorSBU={selectorSBU}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'Riwayat'}
            />}

          {selectedMenu?.label === "Jadwal Dokter" &&               
            <JadwalSection
            filterJadwal={filterJadwal}
            setFilterJadwal={setFilterJadwal}
            selectorSBU={selectorSBU}
            fetchSelectorUnit={fetchSelectorUnit}
            selectorUnit={selectorUnit}
            loadingUnit={loadingUnit}
            setLoadingUnit={setLoadingUnit}
            setMessageState={setMessageState}
            setShowFailed={setShowFailed}
            setShowInfo={setShowInfo}
            selectedSBU={selectedSBU?.value || dataStep1.sbu}
            handleNavigate={handleNavigate}
            setDataStep1={(data) => {
              setDataStep1(data);
              localStorage.setItem("selectedSBU", JSON.stringify({ value: data.sbu, label: data.sbuname }));
            }}
            setDataStep2={setDataStep2}
            setDataStep3={setDataStep3}
            />
            }
                
            {selectedMenu?.label === "Informasi Antrian" &&               
            <AntrianSection
            filterAntrian={filterAntrian}
            setFilterAntrian={setFilterAntrian}
            selectorSBU={selectorSBU}
            fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
            selectorAntrian={selectorAntrian}
            loadingAntrian={loadingAntrian}
            setLoadingAntrian={setLoadingAntrian}
            setMessageState={setMessageState}
            setShowFailed={setShowFailed}
            setShowInfo={setShowInfo}
            selectedSBU={selectedSBU?.value || dataStep1.sbu}
            />}

            {selectedMenu?.label === "Rencana Kontrol" && 
            <PelangganSection
              filterAntrian={filterAntrian}
              setFilterAntrian={setFilterAntrian}
              selectorSBU={selectorSBU}
              // registrationType={registrationType}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'RencanaKontrol'}
            />}
                      
          {selectedMenu?.label === "Kuisioner Pelanggan" && 
              <PelangganSection
              filterAntrian={filterAntrian}
              setFilterAntrian={setFilterAntrian}
              selectorSBU={selectorSBU}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'Pelanggan'}
            />}

          {/* {selectedMenu?.label === "Billing Perawatan" && 
              <PelangganSection
              filterAntrian={filterAntrian}
              setFilterAntrian={setFilterAntrian}
              selectorSBU={selectorSBU}
              fetchSelectorUnitAntrian={fetchSelectorUnitAntrian}
              selectorAntrian={selectorAntrian}
              loadingAntrian={loadingAntrian}
              setLoadingAntrian={setLoadingAntrian}
              setMessageState={setMessageState}
              setShowFailed={setShowFailed}
              setShowInfo={setShowInfo}
              source={'Billing'}
            />} */}

        </Modal.Body>
      </Modal>
    </Container>
        <footer>
          <p className="mb-0 clearfix">
            <span style={{ float: "right" }}>
              Developed by{" "}
              <strong>
                <a
                  href="http://petrograhamedika.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ color: "black" }}
                >
                  Bagian SIRS - PT Petro Graha Medika
                </a>
              </strong>
            </span>
          </p>
        </footer>
      </div>
    </>
  );
}